/* eslint-disable no-empty-pattern */
/* eslint-disable react/prop-types */
import React from 'react'

/** React Router Import */
import { withRouter } from 'react-router-dom'
import { Route } from 'react-router'

/** Breadcrumb Name Map import */
import { breadcrumbNameMap } from './breadcrumbNameMap'

/** MUI Core Import */
import {
   Breadcrumbs as MUIBreadcrumbs,
   Typography,
   Link,
   makeStyles
} from '@material-ui/core'

/** MUI Icons Import */
import HomeIcon from '@material-ui/icons/Home'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import { useStateValue } from 'context/store'

/** Styles */
const useStyles = makeStyles(theme => ({
   breadcrumbLink: {
      display: 'flex',
      color: '#8A8FAB',
      fontSize: 12,
      '&.home': {
         cursor: 'pointer'
      }
   },
   breadcrumbIcon: {
      marginRight: theme.spacing(0.8),
      width: 15,
      height: 17,
      color: '#8A8FAB'
   },
   breadcrumb: {
      flex: 1,
      height: 30,
      display: 'flex',
      alignItems: 'flex-end',
      marginLeft: 17
   },
   breadcrumbOl: {
      marginBottom: '4px'
   }
}))

const Breadcrumbs = ({ history }) => {
   const classes = useStyles()
   const [{ sessionUser }] = useStateValue()
   const userSettings = sessionUser?.settings

   const handleHomeClick = e => {
      e.preventDefault()

      if (
         userSettings?.isAdmin ||
         (sessionUser?.authenticated && userSettings?.policiesAccepted)
      ) {
         history.push('/dashboard')
      }
   }

   const generateBreadcrumbsByURL = pathnames => {
      return pathnames.map((value, index) => {
         const last = index === pathnames.length - 1
         const to = `/${pathnames.slice(0, index + 1).join('/')}`

         return breadcrumbNameMap[to] ? (
            last ? (
               <Typography
                  className={classes.breadcrumbLink}
                  color="textPrimary"
                  key={to}
               >
                  {breadcrumbNameMap[to]}
               </Typography>
            ) : (
               <Link
                  className={classes.breadcrumbLink}
                  color="inherit"
                  to={to}
                  key={to}
               >
                  {breadcrumbNameMap[to]}
               </Link>
            )
         ) : (
            ''
         )
      })
   }

   const generateBreadcrumbsByCSV = location => {
      return breadcrumbNameMap[location.pathname]?.split(';').map((v, i) => {
         return (
            <Typography
               className={classes.breadcrumbLink}
               color="textPrimary"
               key={i}
            >
               {v}
            </Typography>
         )
      })
   }

   return (
      <React.Fragment>
         <Route>
            {({ location }) => {
               const pathnames = location.pathname.split('/').filter(x => x)

               return (
                  <MUIBreadcrumbs
                     classes={{ ol: classes.breadcrumbOl }}
                     className={classes.breadcrumb}
                     separator={
                        <NavigateNextIcon
                           className={classes.breadcrumbIcon}
                           fontSize="small"
                        />
                     }
                     aria-label="breadcrumb"
                  >
                     <Link
                        onClick={handleHomeClick}
                        className={`home ${classes.breadcrumbLink}`}
                        color="inherit"
                        to="/"
                     >
                        <HomeIcon className={classes.breadcrumbIcon} /> Inicio
                     </Link>
                     {pathnames.indexOf('applications') >= 0
                        ? generateBreadcrumbsByCSV(location)
                        : generateBreadcrumbsByURL(pathnames)}
                  </MUIBreadcrumbs>
               )
            }}
         </Route>
      </React.Fragment>
   )
}

export default withRouter(Breadcrumbs)
